<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <adjustment-form>
            </adjustment-form> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import adjustmentForm from './todo-adjustment-form'
export default {
    components: {
        adjustmentForm
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-adjustment-form.vue